import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { 
  ClockIcon,
  ArrowLeftIcon,
  ConstructionIcon
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6">
      <Card className="p-12 max-w-md text-center">
        <div className="space-y-6">
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto">
            <ConstructionIcon className="w-8 h-8 text-teal-600" />
          </div>
          
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Yakında Geliyor!
            </h2>
            <p className="text-gray-600 mb-6">
              Bu özellik şu anda geliştirilme aşamasında. Çok yakında sizlerle olacak.
            </p>
          </div>

          <div className="flex items-center justify-center text-sm text-gray-500 mb-6">
            <ClockIcon className="w-4 h-4 mr-2" />
            <span>Geliştiriliyor...</span>
          </div>

          <Button 
            onClick={() => navigate('/dashboard')}
            className="bg-teal-600 hover:bg-teal-700"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-2" />
            Dashboard'a Dön
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ComingSoon;